import BreadCrumb from "Components/Common/BreadCrumb";
import React, { useCallback, useState } from "react";
import { useEffect } from "react";
import {
    Container,
    CardBody,
    Card,
    Input,
    Label,
    Col,
    Media,
} from "reactstrap";
import { useFormik } from "formik";
import * as Yup from "yup";
import { useSelector, useDispatch } from "react-redux";
import { sellerProfileBussinessUpdate } from 'live-slices/thunk'
import { Link, useNavigate } from "react-router-dom";

import { createSelector } from "reselect";
import MediaUploader from "Components/Common/MediaUploader";
import { DayOption } from "pages/AuthenticationInner/PasswordReset/CoverPasswReset";

import Select from "react-select";
import MediaCenterUploadModal from "pages/Ecommerce/EcommerceProducts/MediaCenter/components/MediaCenterUploadModal";
import BuypassAddressSelector from "Components/Common/BuypassAddressSelector";

const SellerProfileModify = () => {
    document.title = "Seller Profile | BuyPass";
    const selectuserProfile = createSelector(
        (state: any) => state.Business,
        (business) => business?.business
    );
    const seller = useSelector(selectuserProfile);

    const selectUser = createSelector(
        (state: any) => state.User,
        (user) => user?.user
    );

    const user = useSelector(selectUser);

    useEffect(() => {
    }, [user]);

    const options: DayOption[] = [
        { value: "monday", label: "Monday" },
        { value: "tuesday", label: "Tuesday" },
        { value: "wednesday", label: "Wednesday" },
        { value: "thursday", label: "Thursday" },
        { value: "friday", label: "Friday" },
        { value: "saturday", label: "Saturday" },
        { value: "sunday", label: "Sunday" },
    ];

    const dispatch = useDispatch<any>();
    const navigate = useNavigate();
    const [isBusinessAddressSame, setIsBusinessAddressSame] = useState(false);

    const validationSchema = Yup.object({
        firstName: Yup.string()
            .required("The field value is required"),
        // holidayMode : Yup.string()
        // .required("holiday mode is require"),
        // holidayModePeriod : Yup.string()
        // .required("holiday mode is require")
    });

    const handleToggle = () => {
    const newValue = !isBusinessAddressSame;
    setIsBusinessAddressSame(newValue);
    formik.setFieldValue("isBusinessAddressSame", newValue);
    console.log("update", newValue);
  };


    const formik = useFormik({
        initialValues: {
            firstName: seller?.firstName || seller?.fullName || "",
            storeName: seller?.storeName || "",
            shopLogo: seller?.shopLogo || null,
            holidayMode: "false",
            holidayModePeriod: seller?.holiday?.holidayModePeriod || new Date().getTime(),
            address : seller?.address || "",
            timings: [
                {
                    day: "monday",
                    isOpen: seller?.timings?.[0]?.isOpen ?? true,
                    slotsTiming: Array.isArray(seller?.timings?.[0]?.slotsTiming) && seller?.timings?.[0]?.slotsTiming.length > 0
                        ? seller?.timings?.[0]?.slotsTiming
                        : [{ startTime: "09:00", endTime: "18:00" }]
                },
                {
                    day: "tuesday",
                    isOpen: seller?.timings?.[1]?.isOpen ?? true,
                    slotsTiming: Array.isArray(seller?.timings?.[1]?.slotsTiming) && seller?.timings?.[1]?.slotsTiming.length > 0
                        ? seller?.timings?.[1]?.slotsTiming
                        : [{ startTime: "09:00", endTime: "18:00" }]
                },
                {
                    day: "wednesday",
                    isOpen: seller?.timings?.[2]?.isOpen ?? true,
                    slotsTiming: Array.isArray(seller?.timings?.[2]?.slotsTiming) && seller?.timings?.[2]?.slotsTiming.length > 0
                        ? seller?.timings?.[2]?.slotsTiming
                        : [{ startTime: "09:00", endTime: "18:00" }]
                },
                {
                    day: "thursday",
                    isOpen: seller?.timings?.[3]?.isOpen ?? true,
                    slotsTiming: Array.isArray(seller?.timings?.[3]?.slotsTiming) && seller?.timings?.[3]?.slotsTiming.length > 0
                        ? seller?.timings?.[3]?.slotsTiming
                        : [{ startTime: "09:00", endTime: "18:00" }]
                },
                {
                    day: "friday",
                    isOpen: seller?.timings?.[4]?.isOpen ?? true,
                    slotsTiming: Array.isArray(seller?.timings?.[4]?.slotsTiming) && seller?.timings?.[4]?.slotsTiming.length > 0
                        ? seller?.timings?.[4]?.slotsTiming
                        : [{ startTime: "09:00", endTime: "18:00" }]
                },
                {
                    day: "saturday",
                    isOpen: seller?.timings?.[5]?.isOpen ?? true,
                    slotsTiming: Array.isArray(seller?.timings?.[5]?.slotsTiming) && seller?.timings?.[5]?.slotsTiming.length > 0
                        ? seller?.timings?.[5]?.slotsTiming
                        : [{ startTime: "09:00", endTime: "18:00" }]
                },
                {
                    day: "sunday",
                    isOpen: seller?.timings?.[6]?.isOpen ?? true,
                    slotsTiming: Array.isArray(seller?.timings?.[6]?.slotsTiming) && seller?.timings?.[6]?.slotsTiming.length > 0
                        ? seller?.timings?.[6]?.slotsTiming
                        : [{ startTime: "09:00", endTime: "18:00" }]
                },
            ]


        },
        validationSchema,
        onSubmit: (values) => {
            const updatedValues = {
                ...values,
                // holidayMode: values.holidayModePeriod === "true",
                holidayMode:
                typeof values.holidayModePeriod === "string" &&
                !isNaN(Date.parse(values.holidayModePeriod)),
            };
            dispatch(sellerProfileBussinessUpdate({ formData: updatedValues, navigate })
            );
        },
    });


    // const [selectedDays, setSelectedDays] = useState(formik.values.daysOfOperations || []);








    // const handleSelectChange = (selectedOption: DayOption | null) => {
    //     if (
    //         selectedOption && !formik.values.daysOfOperations.includes(selectedOption.value)
    //     ) {
    //         formik.setFieldValue("daysOfOperations", [
    //             ...formik.values.daysOfOperations,
    //             selectedOption.value,
    //         ]);
    //     }
    // };

    // const removeDay = (dayValue: string) => {
    //     formik.setFieldValue(
    //         "daysOfOperations",
    //         formik.values.daysOfOperations.filter((day: any) => day !== dayValue)
    //     );
    // };


    const handleFieldChange = (key: string, e: any) => {
        formik.setFieldValue(key, e.target.value);
    };

    useEffect(() => {
        if (seller && seller.shopLogo) {
            setSelectedShopLogo(seller.nationality.cnicBackImage)
        }

    }, [seller]);

    const [selectedShopLogo, setSelectedShopLogo] = useState<any>();

    const onMediaUpdate = (key: string, value: Media | any) => {
        console.log(key, value);

        if (key === 'shopLogo') {
            setSelectedShopLogo(value);

            let url: string | undefined;
            let media: any | undefined;

            if (Array.isArray(value)) {
                url = value[0]?.url;
                media = value[0];
            } else {
                url = value?.url;
                media = value;
            }
            if (url && media) {
                formik.setFieldValue('shopLogo', {
                    url,
                    metaData: {
                        height: media?.metaData?.height || 0,
                        width: media?.metaData?.width || 0,
                        fileType: media?.metaData?.fileType || 'unknown',
                        fileFormat: media?.metaData?.fileFormat || 'unknown',
                        name: media?.metaData?.name || 'unknown',
                        duration: media?.metaData?.duration || 0,
                    },
                });
            }
        }
    };

    const [mediaCenterUploadModal, setMediaCenterUploadModal] = useState<boolean>(false);

    return (
        <div className="page-content seller-profile-modify">
            {/* <MediaCenterUploadModal
                    show={mediaCenterUploadModal}
                    // submitButton={() => setMediaCenterUploadModal(false)}
                    onCloseClick={() => setMediaCenterUploadModal(false)}
                /> */}
            <Container fluid>
                {/* // addProduct media Upload  */}


                <BreadCrumb title=" Seller Profile" pageTitle="My-Account " pageTitleRoute="/my-account-setting" />
                <form onSubmit={formik.handleSubmit}>
                    <Card>
                        <CardBody className="rounded-3">
                            <div className=" d-flex flex-column gap-3 SellerProfileMain">
                                <div >
                                    <h6 className="fw-bold ">ID Seller<span><i className="ri-information-line ms-2 fs-5 fw-normal"></i></span></h6>
                                    <p className="m-0 p-0" style={{ cursor: 'not-allowed' }} >{seller?. buypassId|| '--'}

                                        {/* <span className="text-success cursor-pointer ms-2">Modify</span> */}
                                    </p>
                                </div>
                                <div className="formContainer" style={{marginBottom: "10px"}} >
                                    <label className="form-label" htmlFor="password-input"><span style={{ color: 'red', display: 'inline' }}>*</span> First and Last Name </label>

                                    <Input
                                        type="text"
                                        className={`form-control pe-5 password-input ${formik.touched.firstName && formik.errors.firstName
                                            ? "is-invalid"
                                            : ""
                                            }`}
                                        placeholder="Name and surname of the person who administers and operates..."
                                        id="password-input"
                                        name="firstName"
                                        data-testing-Id="firstNameInput_sellerProfileModify"
                                        onChange={(e) => {
                                            formik.handleChange(e);
                                            handleFieldChange("firstName", e);
                                        }}
                                        onBlur={formik.handleBlur}
                                        value={formik.values.firstName}

                                    />
                                    {formik.touched.firstName && formik.errors.firstName && (
                                        <div className="invalid-feedback">
                                            {formik.errors.firstName as String}
                                        </div>
                                    )}
                                </div>


                                <div >
                                    <h6 className="fw-bold ">Contact Email address<span><i className="ri-information-line ms-2 fs-5 fw-normal"></i></span></h6>
                                    <p className="m-0 p-0" style={{ cursor: 'not-allowed' }} >{user?.email || '--'}

                                        {/* <span className="text-success cursor-pointer ms-2">Modify</span> */}
                                    </p>
                                </div>

                                <div >
                                    <h6 className="fw-bold ">Contact Mobile Phone Number<span><i className="ri-information-line ms-2 fs-5 fw-normal"></i></span></h6>
                                    <p className="m-0 p-0" style={{ cursor: 'not-allowed' }} >{seller?.phoneNumber || '--'}
                                        {/* <span className="text-success cursor-pointer ms-2">Modify</span> */}
                                    </p>
                                </div>

                                <div className="formContainer">
                                <div >
                                    <h6 className="fw-bold ">Display Name / Shop Name<span><i className="ri-information-line ms-2 fs-5 fw-normal"></i></span></h6>
                                    <p className="m-0 p-0" style={{ cursor: 'not-allowed' }} >{formik.values.storeName || '--'}

                                        {/* <span className="text-success cursor-pointer ms-2">Modify</span> */}
                                    </p>
                                </div>
                                    {/* <label className="form-label" htmlFor="password-input"></label>
                                    <Input
                                        type="text"
                                        className={`form-control pe-5 password-input ${formik.touched.storeName && formik.errors.storeName
                                            ? "is-invalid"
                                            : ""
                                            }`}
                                        style={{ cursor: 'not-allowed' }}
                                        placeholder="Name and surname of the person who administers and operates..."
                                        id="password-input"
                                        name="storeName"
                                        data-testing-Id="storeNameInput_sellerProfileModify"
                                        disabled
                                        onChange={(e) => {
                                            formik.handleChange(e);
                                            handleFieldChange("storeName", e);
                                        }}
                                        onBlur={formik.handleBlur}
                                        value={formik.values.storeName}
 
                                    /> */}
                                    {formik.touched.storeName && formik.errors.storeName && (
                                        <div className="invalid-feedback">
                                            {formik.errors.storeName as String}
                                        </div>
                                    )}
                                </div>

                                <Col md={6} xl={6}>
                                    <h6 className="fw-bold "> <span className="text-danger me-1">*</span> Shop Logo<span><i className="ri-information-line ms-2 fs-5 fw-normal"></i></span></h6>
                                    <div className="mediaUpload-width">
                                        <MediaUploader
                                            onMediaUpdate={(value: any) => onMediaUpdate('shopLogo', value)}
                                            isMultiple={false}
                                            initialMedia={seller.shopLogo}
                                        />
                                    </div>


                                </Col>



                                {/* <div className="formContainer">
                                    <Select
                                        id="stateId"
                                        options={options}
                                        placeholder="Select days of operation"
                                        isClearable
                                        value={null}
                                        className="form-control"
                                        onChange={handleSelectChange}
                                    />

                                    <label className="form-label mt-2" htmlFor="days-operations">
                                        <span style={{ color: "red", display: "inline" }}>*</span> Selected Days
                                    </label>

                                    <div className="selected-days mt-4">
                                        {formik.values.daysOfOperations.map((day: any) => (
                                            <div
                                                key={day}
                                                className="selected-day d-flex align-items-center mb-2"
                                                style={{
                                                    backgroundColor: "#f8f9fa",
                                                    borderRadius: "4px",
                                                    padding: "8px",
                                                    display: "inline-block",
                                                    justifyContent: "center",
                                                }}
                                            >
                                                <span>{options.find((opt) => opt.value === day)?.label}</span>
                                                <div className="CloseIcon" onClick={() => removeDay(day)}>
                                                    X
                                                </div>
                                            </div>
                                        ))}
                                    </div>

                                    <div className="mt-4">
                                        <h6 className="fw-bold">
                                            Holiday Mode
                                            <span>
                                                <i className="ri-information-line ms-2 fs-5 fw-normal"></i>
                                            </span>
                                        </h6>
                                        <div className="mt-4 mt-lg-0">
                                            <div className="form-check form-check-inline">
                                                <Input
                                                    className="form-check-input"
                                                    type="radio"
                                                    name="holidayMode"
                                                    id="true"
                                                    value="true"
                                                    data-testing-Id="holidayModeOnInput_sellerProfileModify"
                                                    onChange={(e) => {
                                                        formik.handleChange(e);
                                                        handleFieldChange("holidayMode", e);
                                                    }}
                                                    onBlur={formik.handleBlur}
                                                    checked={formik.values.holidayMode === "true"}
                                                />
                                                <Label className="form-check-label" htmlFor="true">On</Label>
                                            </div>
                                            <div className="form-check form-check-inline">
                                                <Input
                                                    className="form-check-input"
                                                    type="radio"
                                                    name="holidayMode"
                                                    id="false"
                                                    value="false"
                                                    data-testing-Id="holidayModeOffInput_sellerProfileModify"
                                                    onChange={(e) => {
                                                        formik.handleChange(e);
                                                        handleFieldChange("holidayMode", e);
                                                    }}
                                                    onBlur={formik.handleBlur}
                                                    checked={formik.values.holidayMode === "false"}
                                                />
                                                <Label className="form-check-label ms-2" htmlFor="false">Off</Label>
                                            </div>
                                        </div>
                                    </div>


                                </div> */}


                                <div className="timeSchedule">
                                    {formik?.values?.timings && formik?.values?.timings?.map((timing, index) => (
                                        <div
                                            key={index}
                                            className="itemDv d-flex justify-content-between align-items-center w-100"
                                        >
                                            <div className="d-flex justify-content-between align-items-center widthDvOne">
                                                <p className="text-dark">
                                                    {timing.day.charAt(0).toUpperCase() + timing.day.slice(1)}
                                                </p>
                                                <div className="form-check form-switch">
                                                    <input
                                                        className="form-check-input"
                                                        type="checkbox"
                                                        checked={timing.isOpen}
                                                        onChange={() => {
                                                            const newTimings = [...formik.values.timings];
                                                            newTimings[index].isOpen = !timing.isOpen;
                                                            formik.setFieldValue("timings", newTimings);
                                                        }}
                                                    />
                                                    <label className="p-0 m-0">
                                                        {timing.isOpen ? "Open" : "Close"}
                                                    </label>
                                                </div>
                                            </div>
                                            <div className="widthDvTwo">
                                                <div className="d-flex justify-content-between align-items-center gap-2 dateColRes">
                                                    <div className="w-100">
                                                        <input
                                                            type="time"
                                                            className="timeInputDv"
                                                            value={timing.slotsTiming?.[0]?.startTime || ""}
                                                            disabled={!timing.isOpen}
                                                            onChange={(e) => {
                                                                const newTimings = [...formik.values.timings];
                                                                if (newTimings[index].slotsTiming.length > 0) {
                                                                    newTimings[index].slotsTiming[0].startTime = e.target.value;
                                                                } else {
                                                                    newTimings[index].slotsTiming = [{ startTime: e.target.value, endTime: "" }];
                                                                }
                                                                formik.setFieldValue("timings", newTimings);
                                                            }}
                                                        />
                                                    </div>
                                                    <p>To</p>
                                                    <div className="w-100">
                                                        <input
                                                            type="time"
                                                            className="timeInputDv"
                                                            value={timing.slotsTiming?.[0]?.endTime || ""}
                                                            disabled={!timing.isOpen}
                                                            onChange={(e) => {
                                                                const newTimings = [...formik.values.timings];
                                                                if (newTimings[index].slotsTiming.length > 0) {
                                                                    newTimings[index].slotsTiming[0].endTime = e.target.value;
                                                                } else {
                                                                    newTimings[index].slotsTiming = [{ startTime: "", endTime: e.target.value }];
                                                                }
                                                                formik.setFieldValue("timings", newTimings);
                                                            }}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                </div>




                                <div className="formContainer">
                                    <label className="form-label" htmlFor="password-input">Holiday Mode Period</label>
                                    <Input
                                        type="date"
                                        className="form-control pe-2 password-input"
                                        placeholder=""
                                        id="holiday-mode-period"
                                        name="holidayModePeriod"
                                        min={new Date().toISOString().split("T")[0]}
                                        data-testing-Id="holidayModePeriodInput_sellerProfileModify"
                                        onChange={(e) => {
                                            formik.handleChange(e);
                                            handleFieldChange("holidayModePeriod", e);
                                        }}
                                        onBlur={formik.handleBlur}
                                        value={formik.values.holidayModePeriod}
                                    />
                                    <div>

                                        {/* <div className="dateInput" style={{ justifyContent: "space-between", padding: "10px" ,display: "flex", width: "50%", borderRadius:"5px",border: "2px solid #e2e7ea"}}>
                                        <input type="date" style={{border:" none", width: "42%"}}/>
                                        <input type="date" style={{border:" none", width: "42%"}}/>
                                    </div> */}
                                    </div>
                                </div>
                                
                <div>
                    <h6 className="fw-bold">
                      <span className="text-danger">*</span> Address
                      <span>
                        <i className="ri-information-line ms-2 fs-5 fw-normal"></i>
                      </span>
                    </h6>
                    {/* <div className="form-check form-switch ms-3">
                      <input
                        className="form-check-input"
                        type="checkbox"
                        checked={isBusinessAddressSame}
                        onChange={handleToggle}
                        data-testing-id="sameAdress_businessInformationmodify"
                      />
                      <p>Same as Shop Address</p>
                    </div> */}

                    {!isBusinessAddressSame && (
                      <BuypassAddressSelector formik={formik} />
                    )}
                </div>

                            </div>
                            {/* <div className="w-100 text-center mt-3">
                                <div className="border border-2 mx-auto rounded-pill d-flex justify-content-center align-items-center text-black-50 cursor-pointer fw-bold" style={{ width: '120px', height: "40px" }}>Show More <span className="ms-1 fs-4"><i className="ri-arrow-down-s-line"></i></span></div>
                            </div> */}
                        </CardBody>
                    </Card>
                    <Card>
                        <CardBody className="rounded-3 text-end">
                            <Link to="/seller-profile" className="  ">
                                <button type="button" className="btn btn-outline-secondary  me-2" data-testing-Id="cancelButton_sellerProfileModify" >Cancel</button>
                            </Link>
                            <button type="submit" className="btn btn-secondary ms-auto" data-testing-Id="submitButton_sellerProfileModify">Submit</button>
                        </CardBody>
                    </Card>
                </form>

            </Container>
        </div>
    );
};

export default SellerProfileModify;
